module.exports = __webpack_public_path__ + "static/media/img13.360acdb2.jpg";